/* ============================================================
   ZenPulse™ / RelaxZen™ — CRO Landing Page Scripts
   Archivo: assets/zenpulse.js
   ============================================================ */
document.addEventListener('DOMContentLoaded', function () {

  /* ---------- 1. Galería: click en miniatura cambia imagen principal ---------- */
  document.querySelectorAll('[data-zp-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-zp-main-image]');
    var thumbs = gallery.querySelectorAll('[data-zp-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = thumb.getAttribute('data-full-src') || thumb.querySelector('img').src;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- 2. Selector de ofertas (packs) ---------- */
  document.querySelectorAll('[data-zp-offer-selector]').forEach(function (selector) {
    var offers = selector.querySelectorAll('[data-zp-offer]');
    var form = selector.closest('[data-zp-buybox]')
      ? selector.closest('[data-zp-buybox]').querySelector('form[action*="/cart/add"]')
      : document.querySelector('form[action*="/cart/add"]');
    var variantInput = form ? form.querySelector('[name="id"]') : null;
    var priceNow = document.querySelectorAll('[data-zp-price-now]');
    var priceWas = document.querySelectorAll('[data-zp-price-was]');
    var stickyPriceNow = document.querySelector('[data-zp-sticky-price-now]');

    function selectOffer(offer) {
      offers.forEach(function (o) { o.classList.remove('is-selected'); });
      offer.classList.add('is-selected');
      var radio = offer.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;

      var variantId = offer.getAttribute('data-variant-id');
      if (variantId && variantInput) variantInput.value = variantId;
      var mainImg = document.querySelector('[data-zp-main-image]'); var imageSrc = offer.getAttribute('data-image-src'); if (mainImg && mainImg.tagName === 'IMG' && imageSrc) { mainImg.src = imageSrc; }

      var priceValue = offer.getAttribute('data-price-formatted');
      var wasValue = offer.getAttribute('data-compare-formatted');
      if (priceValue) {
        priceNow.forEach(function (el) { el.textContent = priceValue; });
        if (stickyPriceNow) stickyPriceNow.textContent = priceValue;
      }
      if (wasValue) {
        priceWas.forEach(function (el) { el.textContent = wasValue; el.style.display = ''; });
      } else {
        priceWas.forEach(function (el) { el.style.display = 'none'; });
      }
    }

    offers.forEach(function (offer) {
      offer.addEventListener('click', function () { selectOffer(offer); });
    });
  });

  /* ---------- 3. FAQ acordeón ---------- */
  document.querySelectorAll('[data-zp-faq-item]').forEach(function (item) {
    var question = item.querySelector('[data-zp-faq-question]');
    var answer = item.querySelector('[data-zp-faq-answer]');
    if (!question || !answer) return;
    question.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');
      item.closest('[data-zp-faq-list]').querySelectorAll('[data-zp-faq-item]').forEach(function (el) {
        el.classList.remove('is-open');
        el.querySelector('[data-zp-faq-answer]').style.maxHeight = null;
      });
      if (!isOpen) {
        item.classList.add('is-open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

  /* ---------- 4. Barra sticky de compra en móvil ---------- */
  var stickyBar = document.querySelector('[data-zp-sticky-bar]');
  var heroBuybox = document.querySelector('[data-zp-buybox]');
  if (stickyBar && heroBuybox && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('is-visible');
        } else if (entry.boundingClientRect.top < 0) {
          stickyBar.classList.add('is-visible');
        }
      });
    }, { threshold: 0 });
    observer.observe(heroBuybox);
  }

  var stickyBtn = document.querySelector('[data-zp-sticky-add]');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      var mainForm = document.querySelector('form[action*="/cart/add"] [type="submit"]');
      if (mainForm) {
        mainForm.click();
      }
    });
  }

  /* ---------- 5. Selector de packs de recambios (upsell) ---------- */
  document.querySelectorAll('[data-zp-upsell-selector]').forEach(function (selector) {
    var options = selector.querySelectorAll('[data-zp-upsell-option]');
    var form = selector.closest('form');
    var variantInput = form ? form.querySelector('[name="id"]') : null;
    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        options.forEach(function (o) { o.classList.remove('is-selected'); });
        opt.classList.add('is-selected');
        var radio = opt.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;
        var variantId = opt.getAttribute('data-variant-id');
        if (variantId && variantInput) variantInput.value = variantId;
      });
    });
  });

});
